import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import type { ClinicaAlteracao, ClinicaNova, ClinicaPlataforma, RegistroMaster, UsuarioDaClinica } from "@horofacial/shared";
import { api } from "./api";

export const consultaClinicas = queryOptions({ queryKey: ["plataforma", "clinicas"], queryFn: () => api<ClinicaPlataforma[]>("/plataforma/clinicas") });

export const consultaUsuariosDaClinica = (clinicaId: string) =>
  queryOptions({ queryKey: ["plataforma", "clinicas", clinicaId, "usuarios"], queryFn: () => api<UsuarioDaClinica[]>(`/plataforma/clinicas/${clinicaId}/usuarios`) });

export const consultaRegistrosMaster = (pagina: number, clinicaId?: string) =>
  queryOptions({
    queryKey: ["plataforma", "auditoria", { pagina, clinicaId }],
    queryFn: () => {
      const p = new URLSearchParams({ pagina: String(pagina) });
      if (clinicaId) p.set("clinicaId", clinicaId);
      return api<{ itens: RegistroMaster[]; total: number }>(`/plataforma/auditoria?${p}`);
    },
  });

export function useCriarClinica() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (dados: ClinicaNova) => api<{ id: string; senha: string }>("/plataforma/clinicas", { method: "POST", json: dados }),
    onSuccess: () => cliente.invalidateQueries({ queryKey: ["plataforma"] }),
  });
}

export function useAlterarClinica() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dados }: { id: string; dados: ClinicaAlteracao }) => api(`/plataforma/clinicas/${id}`, { method: "PUT", json: dados }),
    onSuccess: () => cliente.invalidateQueries({ queryKey: ["plataforma"] }),
  });
}

/**
 * Entra numa clínica (como master, ou como um usuário dela) ou volta ao painel. A sessão muda de clínica no servidor:
 * a tela recomeça do início, sem nada da clínica anterior em memória.
 */
export function useMudarDeClinica() {
  return useMutation({
    mutationFn: (destino: { clinicaId: string; usuarioId?: string } | null) =>
      destino ? api("/plataforma/entrar", { method: "POST", json: destino }) : api("/plataforma/painel", { method: "POST", json: {} }),
    onSuccess: () => window.location.assign("/"),
  });
}
